"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var LogLevels;
(function (LogLevels) {
    LogLevels["debug"] = "debug";
    LogLevels["info"] = "info";
    LogLevels["warn"] = "warn";
    LogLevels["error"] = "error";
})(LogLevels || (LogLevels = {}));
class Logger {
    constructor(prefix, allowDebug = true) {
        this.prefix = prefix;
        this.allowDebug = allowDebug;
    }
    debug(...args) {
        if (this.allowDebug) {
            this.log('debug', args);
        }
    }
    info(...args) {
        this.log('info', args);
    }
    warn(...args) {
        this.log('warn', args);
    }
    error(...args) {
        this.log('error', args);
    }
    log(level, args) {
        window.console[level](`${this.prefix} |`, ...args);
    }
}
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map